var render = function render(){var _vm=this,_c=_vm._self._c;return _c('loadList',{attrs:{"loading":_vm.loading},on:{"load":function($event){return _vm.$emit('load')},"fixed":(value) => _vm.$emit('fixed', value)}},_vm._l((_vm.list),function(item,index){return _c('job',{key:index,attrs:{"job":item,"apply-now":_vm.applyNow,"source":_vm.source,"width":_vm.width,"height":_vm.height},on:{"applyed":_vm.applyed}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }